<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p>Introduction and illustrations copyright © 2014 by Lisa Congdon.<br/>All rights reserved. No part of this book may be reproduced in any<br/>form without written permission from the publisher.</p>
<p><a href="#/xhtml/07credit#page_107">Page 107</a> constitutes a continuation of the copyright page.</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN: 978-1-4521-2483-4 (hc)<br/>ISBN: 978-1-4521-3033-0 (epub2, mobi)<br/>ISBN: 978-1-4521-3226-6 (epub fixed format)<br/><br/>Design by Kristen Hewitt<br/><br/>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, CA 94107</p>
<p><a href="http://www.chroniclebooks.com" target="_blank">www.chroniclebooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04-copyright.vue?058793dd